/**
 * Get base path for a URL
 */
export function getUrlAndFolderPath(url: string): string {
    const match = /^.*\//.exec(url);
    return match && match[0];
}
